import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { http } from "../../utils";

export async function fetchPushNotificationById(id) {
  const { data } = await http(`/admin/notifications/${id}`);

  return data;
}

export function usePushNotificationById(id) {
  const { data, ...raResult } = useQuery(["notification-detail", id], () =>
    fetchPushNotificationById(id)
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}

async function cancelPushNotification(id) {
  const data = await http(`/admin/notifications/cancel/${id}`, {
    method: "PATCH",
  });

  return data;
}

export function useCancelPushNotification(id) {
  const queryClient = useQueryClient();

  return useMutation(cancelPushNotification, {
    onSuccess: () => {
      queryClient.invalidateQueries(["notification-detail", id]);
    },
  });
}
